/**
 * KAN-779: выбор порядка строк таблицы Telegram-аккаунтов (включённые первыми,
 * сначала новые, сначала старые по дате подключения). Логика в lib/telegramAccountList.
 */
import { NativeSelect } from '@/components/ui/native-select';
import { ACCOUNT_SORTS, isAccountSort, type AccountSort } from '@/lib/telegramAccountList';

interface AccountSortProps {
  value: AccountSort;
  onChange: (sort: AccountSort) => void;
}

export function AccountSortSelect({ value, onChange }: AccountSortProps): JSX.Element {
  return (
    <NativeSelect
      data-testid="account-sort"
      aria-label="Сортировка аккаунтов"
      className="h-8 w-auto min-w-[180px]"
      options={ACCOUNT_SORTS.map((s) => ({ value: s.value, label: s.label }))}
      value={value}
      onChange={(e) => {
        const next = e.target.value;
        if (isAccountSort(next)) onChange(next);
      }}
    />
  );
}
